import { ChangeEvent, FC, ReactNode } from 'react'
import { useOpen } from '@/hooks'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/16/solid'

const Select: FC<SelectComponentProps> = (props): ReactNode => {
    const { open, setOpen, ref } = useOpen()

    const {
        id,
        label,
        placeholder,
        value,
        required,
        target,
        onChange,
        showError,
        list,
        validationFunction,
        idAccessor,
        valueAccessor,
        disabled
    } = props

    const validation: ValidationFunctionObjectReturnTypes = validationFunction(value)

    return (
        <div className='select-none sm:col-span-2 w-full xl:w-auto z-10' style={disabled ? { opacity: '0.75', pointerEvents: 'none' } : { opacity: '1', pointerEvents: 'auto' }}>
            {
                label !== '' &&
                <label htmlFor={id} className='select-none block mb-1 text-[13px] font-medium text-[#97999b]'>
                    {label}

                    {
                        required &&
                        <span className='text-red-400 ml-1 text-[12px]'>
                            *
                        </span>
                    }
                </label>
            }

            <div className='relative h-auto' ref={ref}>
                <div
                    id={id}
                    // @ts-ignore
                    onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e?.target?.value, target)}
                    className={`flex justify-between h-full border border-[#4A4A4A] bg-[#4A4A4A] text-[#CDD5DA] text-sm rounded-md w-full ${label !== '' ? 'p-2.5' : 'p-2 min-w-full max-h-full md:min-w-[140px] xl:min-w-[175px] xl:max-w-[175px] md:max-w-[140px]'} ${disabled ? 'cursor-default' : 'cursor-pointer'}`}
                    onClick={() => setOpen(!open)}
                >
                    <div>
                        {
                            label !== '' &&
                            value?.trim() === '' &&
                            <span className={(placeholder === 'Select Category' || placeholder === 'Select Tag') ? 'text-[#EBEBEB] opacity-50' : 'text-[#EBEBEB]'}>
                                {placeholder}
                            </span>
                        }

                        {
                            label === '' &&
                            value?.trim() === '' &&
                            <span>
                                {list?.find((item: any) => item[idAccessor] === value)?.[valueAccessor]}
                            </span>
                        }

                        {
                            value?.trim() !== '' &&
                            <span>
                                {list?.find((item: any) => item[idAccessor] === value)?.[valueAccessor]}
                            </span>
                        }
                    </div>

                    <ChevronDownIcon className='w-5 h-5 text-[#CDD5DA]' />
                </div>

                {
                    !disabled &&
                    open &&
                    <div className='custom-scrollbar absolute max-h-[186px] border h-auto w-full top-8 right-0 rounded-md border-[#424242] z-50 my-4 text-base list-none bg-[#4A4A4A] divide-y divide-[#424242]'>
                        {
                            list?.map((item: any) => {
                                return (
                                    <div
                                        key={item[idAccessor]}
                                        className='text-[#CDD5DA] justify-between font-normal cursor-pointer flex items-center py-1.5 px-2 text-[14px] hover:bg-[#404040] rounded-br-md rounded-bl-md transition-all ease-in-out duration-500'
                                        onClick={() => {
                                            // @ts-ignore
                                            onChange(item[idAccessor], target)
                                            setOpen(false)
                                        }}
                                    >
                                        <span>
                                            {item[valueAccessor]}
                                        </span>

                                        <span>
                                            {item[idAccessor] === value && <CheckIcon className='w-4 h-4 text-[#CDD5DA]' />}
                                        </span>
                                    </div>
                                )
                            })
                        }

                        {
                            list?.length === 0 &&
                            <div className='text-[#CDD5DA] justify-between font-normal cursor-pointer flex items-center py-1.5 px-2 text-[14px] hover:bg-[#404040] rounded-br-md rounded-bl-md transition-all ease-in-out duration-500'>
                                <span>
                                    No {target === 'Category' ? 'categories' : target === 'Tags' ? 'tags' : target} where found!
                                </span>
                            </div>
                        }
                    </div>
                }
            </div>

            {
                label !== '' &&
                <p style={validation?.error && showError ? { opacity: '1' } : { opacity: '0' }} className='text-xs h-6 mt-[2px] ml-[2px] text-red-500 transition-all duration-500 ease-in-out'>
                    {validation?.message}
                </p>
            }
        </div>
    )
}

export default Select
